module.exports = __webpack_public_path__ + "img/49.2dae754a.png";